module.exports = __webpack_public_path__ + "static/media/DSC08994-2.56f2d729.jpeg";